




import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class LatencyCircle extends Vue {
  @Prop({ type: String, default: '#00C700' })
  private color!: string;
}
